<template>
  <main-header />
  <section class="hero__section">
    <div class="hero__text">
      <div
        v-motion
        :initial="{ opacity: 0, x: -50 }"
        :visibleOnce="{ opacity: 1, x: 0 }"
      >
        <h1><span>Personalized</span> Gifts for Your Beloved</h1>
        <p>
          Where your furry friends inspire unique gift boxes tailored just for
          them. Experience the joy of gifting that celebrates the bond between
          you and your pet!
        </p>

        <router-link to="/shop">Shop Now</router-link>
      </div>
    </div>

    <img
      ref="heroImage"
      v-motion
      :initial="{ opacity: 0, y: 60 }"
      :enter="{ opacity: 1, y: 0, transition: { duration: 300 } }"
      src="@/assets/images/hero.png"
    />
  </section>
  <!-- <service-section />
    <section class="feature__section">
        <div class="container">
            <featured-products :featuredProducts="featuredProducts" />
        </div>
    </section>

    <banner-section /> -->
  <section class="icon__section" id="icon__section">
    <ul class="icon__container">
      <li
        v-motion
        :initial="{ opacity: 0, scale: 0.6 }"
        :visibleOnce="{ opacity: 1, scale: 1 }"
        :delay="400"
      >
        <svg
          width="45"
          height="45"
          viewBox="0 0 45 45"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M22.5 40.0313L19.7813 37.5563C10.125 28.8 3.75 23.0062 3.75 15.9375C3.75 10.1438 8.2875 5.625 14.0625 5.625C17.325 5.625 20.4562 7.14375 22.5 9.525C24.5438 7.14375 27.675 5.625 30.9375 5.625C36.7125 5.625 41.25 10.1438 41.25 15.9375C41.25 23.0062 34.875 28.8 25.2187 37.5563L22.5 40.0313Z"
            fill="#2B2118"
          />
        </svg>

        <p>MADE WITH LOVE</p>
      </li>
      <li
        v-motion
        :initial="{ opacity: 0, scale: 0.6 }"
        :visibleOnce="{ opacity: 1, scale: 1 }"
        :delay="600"
      >
        <svg
          width="45"
          height="45"
          viewBox="0 0 45 45"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M22.5 15V39.375M5.625 16.875C5.625 16.3777 5.82254 15.9008 6.17417 15.5492C6.52581 15.1975 7.00272 15 7.5 15H37.5C37.9973 15 38.4742 15.1975 38.8258 15.5492C39.1775 15.9008 39.375 16.3777 39.375 16.875V20.625C39.375 21.1223 39.1775 21.5992 38.8258 21.9508C38.4742 22.3025 37.9973 22.5 37.5 22.5H7.5C7.00272 22.5 6.52581 22.3025 6.17417 21.9508C5.82254 21.5992 5.625 21.1223 5.625 20.625V16.875Z"
            stroke="black"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M35.625 22.5V35.625C35.625 36.6196 35.2299 37.5734 34.5266 38.2767C33.8234 38.9799 32.8696 39.375 31.875 39.375H13.125C12.1304 39.375 11.1766 38.9799 10.4733 38.2767C9.77009 37.5734 9.375 36.6196 9.375 35.625V22.5M14.0625 15C12.8193 15 11.627 14.5062 10.7479 13.6271C9.86886 12.748 9.375 11.5557 9.375 10.3125C9.375 9.06932 9.86886 7.87704 10.7479 6.99796C11.627 6.11889 12.8193 5.62503 14.0625 5.62503C15.8713 5.59351 17.6438 6.47114 19.1489 8.14345C20.654 9.81577 21.8218 12.2052 22.5 15C23.1782 12.2052 24.346 9.81577 25.8511 8.14345C27.3562 6.47114 29.1287 5.59351 30.9375 5.62503C32.1807 5.62503 33.373 6.11889 34.2521 6.99796C35.1311 7.87704 35.625 9.06932 35.625 10.3125C35.625 11.5557 35.1311 12.748 34.2521 13.6271C33.373 14.5062 32.1807 15 30.9375 15"
            stroke="black"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        <p>HANDCRAFTED</p>
      </li>
      <li
        v-motion
        :initial="{ opacity: 0, scale: 0.6 }"
        :visibleOnce="{ opacity: 1, scale: 1 }"
        :delay="800"
      >
        <svg
          width="45"
          height="45"
          viewBox="0 0 45 45"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M22.5 40.0313L19.7813 37.5563C10.125 28.8 3.75 23.0062 3.75 15.9375C3.75 10.1438 8.2875 5.625 14.0625 5.625C17.325 5.625 20.4562 7.14375 22.5 9.525C24.5438 7.14375 27.675 5.625 30.9375 5.625C36.7125 5.625 41.25 10.1438 41.25 15.9375C41.25 23.0062 34.875 28.8 25.2187 37.5563L22.5 40.0313Z"
            fill="#2B2118"
          />
        </svg>
        <p>PERFECT FOR ALL</p>
      </li>
    </ul>
  </section>

  <new-arrivals
    :newArrivals="newArrivals"
    @product-clicked="showProductDescription"
  />
  <!--<advert-section />-->
  <product-description
    :isVisible="isDescriptionVisible"
    :product="selectedProduct"
  />
  <product-review />
  <main-footer />
</template>

<script>
import ServiceSection from "@/components/home_components/ServiceSection.vue";
import BannerSection from "@/components/home_components/BannerSection.vue";
import NewArrivals from "@/components/home_components/products/NewArrivals.vue";
import AdvertSection from "@/components/home_components/AdvertSection.vue";
import FeaturedProducts from "@/components/home_components/products/FeaturedProducts.vue";
import ActionButton from "@/components/ActionButton.vue";
import MainHeader from "@/components/MainHeader.vue";
import NewsLetter from "@/components/NewsLetter.vue";
import MainFooter from "@/components/MainFooter.vue";
import ProductDescription from "@/components/home_components/ProductDescription.vue";
import ProductReview from "@/components/home_components/ProductReview.vue";

import axios from "axios";
import { mapActions } from "vuex";

export default {
  name: "HomeView",
  data() {
    return {
      products: [],
      isDescriptionVisible: false,
      selectedProduct: null,
    };
  },
  methods: {
    ...mapActions(["set_products"]),
    handleScroll() {
      // Calculate scroll offset for parallax effect
      this.scrollOffset = window.scrollY;
      const heroImage = this.$refs.heroImage;

      if (heroImage) {
        // Apply transform based on scroll position
        const translateY = Math.min(this.scrollOffset * 0.2, 200); // Adjust factor for sensitivity
        heroImage.style.transform = `translateY(${translateY}px)`;
      }
    },
    showProductDescription(product) {
      this.selectedProduct = product;
      this.isDescriptionVisible = true;

      this.$nextTick(() => {
        const container = document.querySelector(".description__container");
        const offset = window.innerWidth > 768 ? 120 : 80; // desired offset in pixels

        if (container) {
          const targetPosition =
            container.getBoundingClientRect().top + window.scrollY;
          const offsetPosition = targetPosition - offset;

          window.scrollTo({
            top: offsetPosition,
            behavior: "smooth", // Smooth scrolling effect
          });
        }
      });
    },
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    // Remove scroll event listener
    window.removeEventListener("scroll", this.handleScroll);
  },
  components: {
    ServiceSection,
    BannerSection,
    NewArrivals,
    AdvertSection,
    FeaturedProducts,
    ActionButton,
    MainHeader,
    NewsLetter,
    MainFooter,
    ProductDescription,
    ProductReview,
  },
  computed: {
    featuredProducts() {
      return this.products.slice(1, 5);
    },
    newArrivals() {
      return this.products.slice(5, 9);
    },
  },
  async created() {},
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Baskervville:ital@0;1&display=swap");

/* Hero Section */
.hero__section {
  display: grid;
  grid-template-columns: 1fr;
  height: 90vh;
  padding: 0;
  background-color: var(--cosmic-latte);
  z-index: 1;
  position: relative;
  overflow: hidden;
}

.hero__text {
  padding: 7rem 5rem;
  text-align: center;
  position: absolute;
  font-family: "Baskervville", serif;
  width: 100%;
}

.hero__text div {
  transition: all 0.25s linear;
  font-family: inherit;
}

.hero__text h1 {
  font-size: 4rem;
  line-height: 1.2;
  max-width: 40rem;
  margin: auto;
  margin-bottom: 5rem;
  font-family: inherit;
}

.hero__text h1 span {
  font-family: inherit;
}

.hero__text p {
  display: none;
}

.hero__section img {
  height: 60%;
  justify-self: center;
  align-self: self-end;
  margin-bottom: -50px;
  transition: transform 0.2s ease-out;
  will-change: transform;
  overflow: hidden;
}

.hero__section a {
  line-height: 1;
  padding: 1.3rem 2rem;
  background-color: #2b2118;
  color: #fff;
  border-radius: 3px;
  font-size: 1.5rem;
  text-transform: uppercase;
  font-weight: 400;
}

.icon__section {
  width: 100%;
  background-color: #f6e8e0;
  z-index: 2;
  position: relative;
}

.icon__container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 2rem;
  max-width: 1280px;
  gap: 1rem;
  padding: 0;
}

.icon__container li {
  flex-shrink: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  font-weight: 400;
  font-size: 1.5rem;
  text-align: center;
  transition: all 0.25s linear;
  margin-top: 0.5rem;
  height: 8rem;
  width: 18rem;
  margin-top: 1.5rem;
}

.icon__container li p {
  height: 4rem;
  line-height: 1;
  font-size: 10px;
}

@media (min-width: 600px) {
  .hero__section img {
    height: 80%;
    margin-bottom: -150px;
  }
  .icon__container li p {
    font-size: 16px;
  }
}

@media (min-width: 1020px) {
  .hero__section {
    grid-template-columns: 3fr 4fr;
  }

  .hero__text {
    position: relative;
    align-self: center;
    transform: translateY(-50px);
  }

  .hero__text h1 {
    font-size: 5rem;
    margin-bottom: 2rem;
  }

  .hero__text p {
    display: block;
    max-width: 40rem;
    margin: auto;
    margin-bottom: 3rem;
  }

  .hero__section img {
    margin-bottom: unset;
    justify-self: auto;
    height: 90%;
  }

  .icon__container {
    gap: 30rem;
    margin: auto;
    justify-content: center;
  }

  .icon__container li {
    width: unset;
  }
}

@media (min-width: 1300px) {
}

/*.title {
    font-family: 'Baskervville', serif;
}*/
</style>